<template>
  <v-form v-model="valid" ref="form">
    <v-text-field ref="title" dense v-model="title" label="Tên khoản thu" placeholder="Nhập Tên Khoản Thu" required
      outlined></v-text-field>
    <v-text-field outlined ref="code" dense v-model="code" label="Mã" disabled></v-text-field>
    <currency-input dense v-model="price" label="Khoản thu" placeholder="Nhập Khoản Thu"></currency-input>

    <v-select :items="option" outlined ref="type" dense v-model="type" label="Phân Loại Khoản Thu"></v-select>
  </v-form>
</template>

<script>
import CurrencyInput from '@/components/basic/input/CurrencyInput.vue'
export default {
  components: { CurrencyInput },
  data: () => ({
    option: ['Khoản thu dài hạn', 'Khoản thu ngắn hạn', 'Khoản thu khác'],
    valid: true,
    code: '',
    title: '',
    price: '',
    type: '',
  }),
  props: {
    p: Object,
  },
  created() {
    this.reset()
  },
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.code = this.p.code
      this.title = this.p.title
      this.price = this.p.price
      this.type = this.p.type
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        title: this.title,
        price: this.price,
        type: this.type,
        code: this.code,
      }
    },
  },
}
</script>

<style scoped></style>
